import classNames from 'classnames';
import { Component, ReactNode } from 'react';
import IwLink from '../../iwRouter/IwLink';
import styles from './NavLink.module.css';

class NavLink extends Component<{
    to: string;
    linkStep?: string;
    icon?: ReactNode;
    disableRedirect?: boolean;
    className?: string;
    activeClassName?: string;
    'data-testid'?: string;
}> {
    render() {
        const {
            to,
            linkStep,
            icon,
            disableRedirect,
            className,
            activeClassName,
            children
        } = this.props;

        return (
            <IwLink
                data-testid={this.props['data-testid']}
                to={to}
                linkStep={linkStep}
                activeClassName={classNames([
                    styles.NavLinkActive,
                    styles.link,
                    activeClassName
                ])}
                className={classNames([styles.NavLink, styles.link, className])}
                disableRedirect={disableRedirect}
            >
                {icon && <div className={styles.NavLinkIcon}>{icon}</div>}
                {children}
            </IwLink>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default NavLink;
